module.exports = __webpack_public_path__ + "img/icon_trash.b6996e74.svg";